import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsInterventionsMetricsComponent } from './fields-interventions-metrics.component';
import {TimePieChartModule} from '../../reports/charts/time-pie-chart/time-pie-chart.module';
import {DxScrollViewModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldsInterventionsMetricsComponent],
    imports: [
        CommonModule,
        TimePieChartModule,
        DxScrollViewModule
    ],
  exports: [FieldsInterventionsMetricsComponent]
})
export class FieldsInterventionsMetricsModule { }
